module.exports = __webpack_public_path__ + "static/palitaw-f50518be4e3b799264a2f72f1ec6f2b3.jpg";